import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d2f8196"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home page-header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "This is the Dashboard")
], -1))
const _hoisted_2 = { class: "home page" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-30" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Website Design Intake Forms", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "website-design-intake-forms" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Company Email:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Website Purpose:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Target Market:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Domain Purchased?", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Social Media Intake Forms", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "social-media-intake-forms" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Company Email:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Post Frequency:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Custom Graphics Requirements ", -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "content" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "App Development Intake Forms", -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "social-media-intake-forms" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Company Email:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Post Frequency:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Custom Graphics Requirements ", -1))
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "content all-btn" }
const _hoisted_31 = { class: "col-30" }
const _hoisted_32 = { class: "content" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Latest Contact Form Emails ", -1))
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "content" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "content all-btn" }
const _hoisted_42 = { class: "col-30" }
const _hoisted_43 = { class: "content" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Latest Posts", -1))
const _hoisted_45 = { class: "post-content" }
const _hoisted_46 = { class: "post-title" }
const _hoisted_47 = { class: "content" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Latest Projects", -1))
const _hoisted_49 = { class: "post-content" }
const _hoisted_50 = { class: "post-title" }
const _hoisted_51 = { class: "content" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Latest Services", -1))
const _hoisted_53 = { class: "post-content" }
const _hoisted_54 = { class: "post-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (_ctx.websiteForms.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "No forms filled out yet."))
              : _createCommentVNode("", true),
            (_ctx.websiteForms.length >>> 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.websiteForms.slice(0,2), (form, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "form",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h4", null, "Filled Out By: " + _toDisplayString(form.company_name), 1),
                      _createElementVNode("p", null, [
                        _hoisted_9,
                        _createTextVNode(" " + _toDisplayString(form.company_email_address), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_10,
                        _createTextVNode(" " + _toDisplayString(form.website_purpose), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_11,
                        _createTextVNode(" " + _toDisplayString(form.target_market), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_12,
                        _createTextVNode(" " + _toDisplayString(form.did_purchase_domain), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "btn",
                        onClick: ($event: any) => (_ctx.$router.push('/onboarding-forms/website-design/' + _ctx.websiteFormIDs[index]))
                      }, "More Details", 8, _hoisted_13)
                    ])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            (_ctx.socialMediaForms.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, "No forms filled out yet."))
              : _createCommentVNode("", true),
            (_ctx.socialMediaForms.length >>> 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.socialMediaForms.slice(0,2), (form, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "form",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("h4", null, "Filled Out By: " + _toDisplayString(form.company_name), 1),
                      _createElementVNode("p", null, [
                        _hoisted_18,
                        _createTextVNode(" " + _toDisplayString(form.company_email_address), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_19,
                        _createTextVNode(" " + _toDisplayString(form.post_frequency), 1)
                      ]),
                      _hoisted_20,
                      _createElementVNode("p", null, _toDisplayString(form.graphics_details), 1),
                      _createElementVNode("button", {
                        class: "btn",
                        onClick: ($event: any) => (_ctx.$router.push('/onboarding-forms/social-media/' + _ctx.socialMediaFormIDs[index]))
                      }, "More Details", 8, _hoisted_21)
                    ])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            (_ctx.appDevForms.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_24, "No forms filled out yet."))
              : _createCommentVNode("", true),
            (_ctx.appDevForms.length >>> 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.appDevForms.slice(0,2), (form, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "form",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("h4", null, "Filled Out By: " + _toDisplayString(form.company_name), 1),
                      _createElementVNode("p", null, [
                        _hoisted_26,
                        _createTextVNode(" " + _toDisplayString(form.company_email_address), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_27,
                        _createTextVNode(" " + _toDisplayString(form.post_frequency), 1)
                      ]),
                      _hoisted_28,
                      _createElementVNode("p", null, _toDisplayString(form.graphics_details), 1),
                      _createElementVNode("button", {
                        class: "btn",
                        onClick: ($event: any) => (_ctx.$router.push('/onboarding-forms/app-development/' + _ctx.appDevFormIDs[index]))
                      }, "More Details", 8, _hoisted_29)
                    ])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("button", {
              class: "btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/onboarding-forms')))
            }, "See All")
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            (_ctx.all_emails.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_34, "No forms filled out yet."))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_emails.slice(0,3), (contact, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "contact-form",
                key: index
              }, [
                _createElementVNode("div", _hoisted_35, [
                  (contact.name != null)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_36, _toDisplayString(contact.name), 1))
                    : _createCommentVNode("", true),
                  (contact.email != null)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(contact.email), 1))
                    : _createCommentVNode("", true),
                  (contact.message != null)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_38, "Message"))
                    : _createCommentVNode("", true),
                  (contact.message != null)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 3,
                        innerHTML: contact.message
                      }, null, 8, _hoisted_39))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: ($event: any) => (_ctx.contactPotentialClient(contact))
                  }, "Contact", 8, _hoisted_40)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("button", {
              class: "btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/contact-forms')))
            }, "See All")
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPosts, (post, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "current-posts",
                key: index
              }, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("h5", _hoisted_46, _toDisplayString(post.postTitle), 1)
                ])
              ]))
            }), 128)),
            _createElementVNode("button", {
              class: "btn all-posts",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/posts')))
            }, "Manage Posts")
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentProjects, (project, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "current-posts",
                key: index
              }, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("h5", _hoisted_50, _toDisplayString(project.projectTitle), 1)
                ])
              ]))
            }), 128)),
            _createElementVNode("button", {
              class: "btn all-posts",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/portfolio')))
            }, "Manage Projects")
          ]),
          _createElementVNode("div", _hoisted_51, [
            _hoisted_52,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentServices, (post, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "current-posts",
                key: index
              }, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("h5", _hoisted_54, _toDisplayString(post.postTitle), 1)
                ])
              ]))
            }), 128)),
            _createElementVNode("button", {
              class: "btn all-posts",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/services')))
            }, "Manage Services")
          ])
        ])
      ])
    ])
  ], 64))
}